module.exports = __webpack_public_path__ + "img/09.e25596cb.jpg";